import {productDataDictionary} from 'constants/productCardConstants'
import type {ProductType} from 'types/orderTypes'
import type {PropertyType} from 'types/propertyTypes'

export const isAvailable = (productType: ProductType, {pid}: Pick<PropertyType, 'pid'>) => {
  return !productDataDictionary[productType].needPID || !!pid
}
